import { useContext } from 'react';

import PaymentContext from './PaymentContext.tsx';

const usePaymentContext = () => {
  const context = useContext(PaymentContext);

  return context;
};

export default usePaymentContext;
